exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._16jl9{overflow-x:auto;height:100%;z-index:1}._16jl9 ._2Ynti{position:relative;background-color:#F0F4F7;min-width:894px;height:100%;transform:scale(1)}._16jl9 ._2Ynti ._1dSoz{overflow-y:auto;width:100%;position:relative;height:100%}._16jl9 ._2Ynti ._1dSoz ._3I2Hi{position:relative;width:100%;margin:0 auto;box-sizing:border-box}._16jl9 ._2Ynti ._1dSoz ._3I2Hi ._3ABhs{padding-top:30px;padding-bottom:24px}._16jl9 ._2Ynti ._1dSoz ._3I2Hi ._3ABhs._1y8ck{box-sizing:content;min-height:30px;padding-top:18px;padding-bottom:18px;position:relative;-webkit-animation:_1Bmp3 0.2s;animation:_1Bmp3 0.2s}@-webkit-keyframes _1Bmp3{0%{opacity:0;bottom:-20px}100%{opacity:1;bottom:0px}}@keyframes _1Bmp3{0%{opacity:0;bottom:-20px}100%{opacity:1;bottom:0px}}._16jl9 ._2Ynti ._1dSoz ._3I2Hi._3rVkK ._3ABhs._1y8ck{padding-bottom:12px}._16jl9 ._2Ynti ._1dSoz ._3I2Hi ._2WHZu{background-color:#F0F4F7}._16jl9 ._2Ynti ._1dSoz ._3I2Hi._1y8ck{top:0px;position:fixed;z-index:1200;background-color:#F0F4F7;border-bottom:1px solid #DFE5EB}._16jl9 ._2Ynti ._1dSoz ._3yLXw{padding-bottom:48px;position:relative}._16jl9 ._2Ynti ._1dSoz._3rVkK ._3yLXw{margin-top:24px}._24bMg{position:absolute;overflow:hidden;top:0;width:100%;height:100%}._24bMg::after{content:'';position:absolute;top:0;width:100%;height:100%;background-color:rgba(22,45,61,0.42)}._24bMg ._3sIlx{background-repeat:no-repeat;background-size:cover;background-position:center;position:absolute;top:-30px;bottom:-30px;left:-30px;right:-30px;filter:blur(12px)}.wVngI{position:absolute;top:0;width:100%}._1KYBr{padding:0 48px;margin:0 auto}._21Exv{position:relative}._2SKqY{padding-left:0;padding-right:0}._2v9RF{overflow-x:auto;padding-right:0}._2v9RF ._21Exv{display:inline-block;margin-right:48px}._2MgVb{position:-webkit-sticky;position:sticky;z-index:1100;background-color:#F0F4F7}._3x7Ju{height:100%}\n", ""]);

// Exports
exports.locals = {
	"D10": "#162D3D",
	"d10": "#162D3D",
	"D20": "#32536A",
	"d20": "#32536A",
	"D30": "#577083",
	"d30": "#577083",
	"D40": "#7A92A5",
	"d40": "#7A92A5",
	"D50": "#B6C1CD",
	"d50": "#B6C1CD",
	"D55": "#CBD3DC",
	"d55": "#CBD3DC",
	"D60": "#DFE5EB",
	"d60": "#DFE5EB",
	"D70": "#F0F4F7",
	"d70": "#F0F4F7",
	"D80": "#fff",
	"d80": "#fff",
	"B00": "#2B81CB",
	"b00": "#2B81CB",
	"B05": "#308DDD",
	"b05": "#308DDD",
	"B10": "#3899EC",
	"b10": "#3899EC",
	"B20": "#4EB7F5",
	"b20": "#4EB7F5",
	"B25": "#A1D7FB",
	"b25": "#A1D7FB",
	"B27": "#B3E0FB",
	"b27": "#B3E0FB",
	"B30": "#C1E4FE",
	"b30": "#C1E4FE",
	"B40": "#DAEFFE",
	"b40": "#DAEFFE",
	"B50": "#EAF7FF",
	"b50": "#EAF7FF",
	"B60": "#F4FAFE",
	"b60": "#F4FAFE",
	"F00": "#AADBFC",
	"f00": "#AADBFC",
	"P00": "#8E21B1",
	"p00": "#8E21B1",
	"P10": "#AA4DC8",
	"p10": "#AA4DC8",
	"P20": "#CD68ED",
	"p20": "#CD68ED",
	"P30": "#E5C9EE",
	"p30": "#E5C9EE",
	"P40": "#EEDBF4",
	"p40": "#EEDBF4",
	"P50": "#FAEEFF",
	"p50": "#FAEEFF",
	"P60": "#FAF7FC",
	"p60": "#FAF7FC",
	"O00": "#EA5F0E",
	"o00": "#EA5F0E",
	"O10": "#FB7D33",
	"o10": "#FB7D33",
	"O20": "#FF9A48",
	"o20": "#FF9A48",
	"R00": "#D6453D",
	"r00": "#D6453D",
	"R05": "#D8504C",
	"r05": "#D8504C",
	"R10": "#EE5951",
	"r10": "#EE5951",
	"R20": "#f66",
	"r20": "#f66",
	"R30": "#FFD7D7",
	"r30": "#FFD7D7",
	"R40": "#FFE1E1",
	"r40": "#FFE1E1",
	"R50": "#FFEBEB",
	"r50": "#FFEBEB",
	"R60": "#FFF5F5",
	"r60": "#FFF5F5",
	"G00": "#44823F",
	"g00": "#44823F",
	"G05": "#61AD5A",
	"g05": "#61AD5A",
	"G10": "#60BC57",
	"g10": "#60BC57",
	"G20": "#80C979",
	"g20": "#80C979",
	"G30": "#C9EEBC",
	"g30": "#C9EEBC",
	"G40": "#DEF4D4",
	"g40": "#DEF4D4",
	"G50": "#EDF9E5",
	"g50": "#EDF9E5",
	"G60": "#F2FBEF",
	"g60": "#F2FBEF",
	"Y00": "#C68801",
	"y00": "#C68801",
	"Y05": "#EDA200",
	"y05": "#EDA200",
	"Y10": "#FDB10C",
	"y10": "#FDB10C",
	"Y20": "#FAC249",
	"y20": "#FAC249",
	"Y30": "#FEF0BA",
	"y30": "#FEF0BA",
	"Y40": "#FEF4CD",
	"y40": "#FEF4CD",
	"Y50": "#FDF7DF",
	"y50": "#FDF7DF",
	"Y60": "#FFFCF0",
	"y60": "#FFFCF0",
	"A1": "#3370FB",
	"a1": "#3370FB",
	"A2": "#7852D2",
	"a2": "#7852D2",
	"A3": "#17B0E2",
	"a3": "#17B0E2",
	"A4": "#C53E99",
	"a4": "#C53E99",
	"A5": "#FDB10C",
	"a5": "#FDB10C",
	"A6": "#3D9FA1",
	"a6": "#3D9FA1",
	"B1": "#EF73C0",
	"b1": "#EF73C0",
	"B2": "#FF8D41",
	"b2": "#FF8D41",
	"B3": "#ED6779",
	"b3": "#ED6779",
	"B4": "#125b8f",
	"b4": "#125b8f",
	"C1": "#4abd81",
	"c1": "#4abd81",
	"C2": "#2682CD",
	"c2": "#2682CD",
	"C3": "#68A4D5",
	"c3": "#68A4D5",
	"C4": "#FF8E8C",
	"c4": "#FF8E8C",
	"D10-05": "rgba(22,45,61,0.05)",
	"d1005": "rgba(22,45,61,0.05)",
	"D10-10": "rgba(22,45,61,0.1)",
	"d1010": "rgba(22,45,61,0.1)",
	"D10-20": "rgba(22,45,61,0.2)",
	"d1020": "rgba(22,45,61,0.2)",
	"D10-30": "rgba(22,45,61,0.3)",
	"d1030": "rgba(22,45,61,0.3)",
	"pageWrapper": "_16jl9",
	"page": "_2Ynti",
	"scrollableContainer": "_1dSoz",
	"pageHeaderContainer": "_3I2Hi",
	"headerWrapper": "_3ABhs",
	"minimized": "_1y8ck",
	"entrance": "_1Bmp3",
	"hasTail": "_3rVkK",
	"tail": "_2WHZu",
	"contentContainer": "_3yLXw",
	"imageBackgroundContainer": "_24bMg",
	"imageBackground": "_3sIlx",
	"gradientBackground": "wVngI",
	"contentHorizontalLayout": "_1KYBr",
	"contentFloating": "_21Exv",
	"contentFullWidth": "_2SKqY",
	"horizontalScroll": "_2v9RF",
	"sticky": "_2MgVb",
	"stretchVertically": "_3x7Ju"
};